// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"8d81a268","460":"79fbcc2e","590":"de1d5afa","641":"d1226598","704":"49ca1476","824":"a2d6f9bb"}[chunkId] + ".chunk.css";
};